// FMNV: Funktionalität, damit nur verfügbare Varianten angezeigt werden, abhängig der Stoffauswahl

function updateAvailableVariants() {
  const variantSelects = document.querySelector('variant-selects');
  if (!variantSelects) return;
  
  const jsonElement = variantSelects.querySelector('script[type="application/json"]');
  if (!jsonElement) return;

  const variants = JSON.parse(jsonElement.textContent);

  // 1. Dynamisch herausfinden, welche Option was ist
  // Wir suchen die Namen im HTML und schauen, an welcher Stelle sie stehen
  const fieldsets = Array.from(document.querySelectorAll('fieldset.product-form__input'));
  const optionMapping = {};
  
  fieldsets.forEach((fieldset, index) => {
    const label = fieldset.querySelector('.form__label')?.textContent || "";
    if (label.includes("Konfiguration")) optionMapping["Konfiguration"] = `option${index + 1}`;
    if (label.includes("Stoff")) optionMapping["Stoff"] = `option${index + 1}`;
    if (label.includes("Farbe")) optionMapping["Farbe"] = `option${index + 1}`;
  });

  // 2. Aktuelle Auswahl der Steuer-Elemente (alles außer Farbe)
  const currentSelections = {};
  if (optionMapping["Konfiguration"]) {
    currentSelections[optionMapping["Konfiguration"]] = document.querySelector('input[name="Konfiguration"]:checked')?.value;
  }
  if (optionMapping["Stoff"]) {
    currentSelections[optionMapping["Stoff"]] = document.querySelector('input[name="Stoff"]:checked')?.value;
  }

  // 3. Alle Farbkacheln prüfen
  const colorInputs = document.querySelectorAll('input[name="Farbe"]');
  const colorOptionKey = optionMapping["Farbe"];

  colorInputs.forEach(input => {
    const colorValue = input.value;
    
    // Prüfen, ob es eine Variante gibt, die die aktuellen Selektionen + diese Farbe hat
    const isPossible = variants.some(v => {
      let match = true;
      // Prüfe alle aktiven Filter (Konfiguration, Stoff)
      for (let key in currentSelections) {
        if (currentSelections[key] && v[key] !== currentSelections[key]) {
          match = false;
        }
      }
      // Prüfe, ob die Farbe an der richtigen Position matcht
      return match && v[colorOptionKey] === colorValue;
    });

    const label = document.querySelector(`label[for="${input.id}"]`);
    if (isPossible) {
      input.classList.remove('variant-option--hidden');
      if(label) label.classList.remove('variant-option--hidden');
    } else {
      input.classList.add('variant-option--hidden');
      if(label) label.classList.add('variant-option--hidden');
    }
  });

  // 4. Auto-Korrektur
  const checkedColor = document.querySelector('input[name="Farbe"]:checked');
  if (checkedColor && checkedColor.classList.contains('variant-option--hidden')) {
    const firstVisible = document.querySelector('input[name="Farbe"]:not(.variant-option--hidden)');
    if (firstVisible) firstVisible.click();
  }
}

document.addEventListener('change', updateAvailableVariants);
setTimeout(updateAvailableVariants, 100);


document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('.sample-bar');
  if (!bar) return;

  const setBarH = () => {
    const h = Math.ceil(bar.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--sample-bar-h', `${h}px`);
  };

  setBarH();

  // reagiert auf Inhalt + Responsive Changes
  new ResizeObserver(setBarH).observe(bar);
  window.addEventListener('resize', setBarH);
});